import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';

export default function SingleBarPlotGraph({
    data,
    width = '100%',   // Set width to 100% for responsiveness
    height = 400,     // Fixed height to maintain aspect ratio
    marginTop = 20,
    marginRight = 20,
    marginBottom = 50,
    marginLeft = 50
}) {
    const svgRef = useRef();

    useEffect(() => {
        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove(); // Clear previous content

        // Generate the months array
        const now = new Date();
        const months = Array.from({ length: data.length }, (_, i) => {
            const date = new Date(now);
            date.setMonth(date.getMonth() - i);
            return date;
        }).reverse();

        // Format function for month display
        const formatMonth = d3.timeFormat("%b %Y");

        // Calculate actual width based on the container's width
        const actualWidth = svg.node().clientWidth;

        // Scale for x-axis (months)
        const x = d3.scaleBand()
            .domain(months.map(d => formatMonth(d))) // Format each date for display
            .range([marginLeft, actualWidth - marginRight])
            .padding(0.2);

        // Scale for y-axis (values)
        const y = d3.scaleLinear()
            .domain([0, d3.max(data)]) // Adjust domain based on data
            .nice()
            .range([height - marginBottom, marginTop]);

        // Axes
        const xAxis = d3.axisBottom(x)
            .tickSize(0) // Remove ticks
            .tickFormat(d => formatMonth(new Date(d))); // Format tick labels

        const yAxis = d3.axisLeft(y)
            .ticks(5); // Adjust number of ticks as needed

        // Append x-axis
        svg.append("g")
            .attr("transform", `translate(0, ${height - marginBottom})`)
            .call(xAxis)
            .selectAll("text")
            .style("text-anchor", "middle"); // Center align text

        // Append y-axis
        svg.append("g")
            .attr("transform", `translate(${marginLeft}, 0)`)
            .call(yAxis);

        // Bars
        svg.selectAll("rect")
            .data(data)
            .enter().append("rect")
            .attr("x", (d, i) => x(formatMonth(months[i])))
            .attr("y", d => y(d))
            .attr("width", x.bandwidth() * 0.7)
            .attr("height", d => height - marginBottom - y(d))
            .attr("fill", "#5383ec"); // Set bar color

    }, [data, height, marginBottom, marginLeft, marginRight, marginTop, width]);

    return (
        <svg
            ref={svgRef}
            width={width}
            height={height}
            viewBox={`0 0 ${width === '100%' ? 640 : width} ${height}`} // Dynamic viewBox
            style={{ maxWidth: '100%', height: 'auto' }} // Ensure responsiveness
        ></svg>
    );
}

